import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
// services
import { AppLoaderService } from '../../services/app-loader.service';
import { CopyService } from '../../services/app-copy.service';
// model
import { AppState } from '../../../booking/models/app-state.interface';
@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent implements OnInit, OnDestroy {

  private _copyInitSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _loaderItemSubscription: Subscription;

  public showLoader = false;
  public showLoaderMessage = false;
  public customCopy = '';
  public onlyCaptions = false;
  public copyLoaded: Boolean = false;
  public appCopy;
  public selectedLanguage = '';
  public onlyLoader = false;

  constructor(
    private _appStore: Store<AppState>,
    private _appLoaderService: AppLoaderService,
    private _copyService: CopyService,

    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {

    // will work without reloading
    this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data

        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          if (isPlatformBrowser(this.platformId)) {
            this.getCopy();
          }
        }
        this._userLanguageSubscription = this._appStore.select('copyReducer')
          .subscribe((res: any) => {
            this.selectedLanguage = res.language
          })

      });

    this._loaderItemSubscription = this._appLoaderService.loaderState$
      .subscribe(res => {
        this.showLoaderMessage = false;
        if (res.show === true) {
          this.customCopy = res.data;
          this.onlyLoader = res.onlyLoader;
          this.onlyCaptions = res.onlyCaptions;
          this.showLoader = true;
          setTimeout(() => {
            this.showLoaderMessage = true;
          }, 5000); // to allow the loader to show
        } else {
          this.showLoader = false;
          this.showLoaderMessage = false;
        }
      });
  }


  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'loading',
      ['panelHeader']
    );

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };
  }

  ngOnDestroy() {
    if (this._copyInitSubscription) { this._copyInitSubscription.unsubscribe(); }
    this._loaderItemSubscription.unsubscribe();
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
  }

}
